import styled from 'styled-components';
import { Button, Tooltip, FormLoader } from '@teamfabric/copilot-ui';
import { useState } from 'react';
import { Editor } from 'components/Editor/TransformationEditor';
import { useFormik } from 'formik';
import { Text, Card } from '@mantine/core';
import { makePost } from 'utils/httpWrapper';
import { isEmpty } from 'utils/commonFunc';
import { USER_LOCAL_STORAGE_KEY } from 'contexts/auth';

const StyledContainer = styled.div``;

const ActionsContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: 18px;
`;

const StyledEditorWrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  column-gap: 10px;
  .editor__labels {
    margin: 12px 0 6px 6px;
  }
  .editor-transformation-response-query {
    height: 478px !important;
  }
  .editor-transformation-header-error {
    height: 50px !important;
  }
`;

const jsonStringify = req => {
  return JSON.stringify(req, null, 2);
};

const TestTransformations: any = ({ data, onExtensionChange }) => {
  const [loading, setLoading] = useState(false);
  const [extensions, setExtensions] = useState({});
  const [errorsWithData, setErrorsWithData] = useState(false);
  const [initialValues] = useState({
    query: '',
    variable: '',
    headers: '',
    errorsWithData: '',
    transformationResult: '',
  });

  const user = JSON.parse(localStorage.getItem(USER_LOCAL_STORAGE_KEY));
  const accountId = user?.accountId;
  const formik = useFormik({
    enableReinitialize: true,
    initialValues,
    onSubmit: async (values, action) => {
      setLoading(true);
      action.setFieldValue('transformationResult', '');
      const body = {
        query: values.query,
      };

      const headers = JSON.parse(values.headers);
      try {
        const url = `/management/debug/${accountId}/graphql`;
        const resp = await makePost({ url, body, headers });
        if (resp['data']) {
          if (resp['data'].errors && resp['data'].data) {
            action.setFieldValue('transformationResult', jsonStringify(resp['data'].data));
            action.setFieldValue('errorsWithData', jsonStringify(resp['data'].errors[0]));
            setErrorsWithData(true);
          } else if (resp['data'].errors !== undefined) {
            action.setFieldValue('transformationResult', jsonStringify(resp['data'].errors[0]));
          } else {
            action.setFieldValue('transformationResult', jsonStringify(resp['data'].data));
          }

          setExtensions(resp['data']?.extensions?.logs);
        } else {
          action.setFieldValue(
            'transformationResult',
            'Something went wrong. Please contact support@fabric.inc.',
          );
        }
      } catch (err) {
        action.setFieldValue('transformationResult', err.response.data);
      } finally {
        setLoading(false);
      }
    },
  });

  if (loading && !isEmpty(extensions)) {
    onExtensionChange(extensions);
  }

  return (
    <StyledContainer data-testid="editor-transformation-container">
      <ActionsContainer>
        <Button
          type="button"
          isPrimary={false}
          onClick={formik.resetForm}
          text="Reset"
          style={{ marginRight: '12px' }}
        />
        <div>
          <Tooltip className="custom-tooltip" text="Please enter query" />
          <Button
            disabled={formik.values.query ? false : true}
            data-testid={'testing-run-button'}
            type="submit"
            form="testingForm"
            onClick={formik.handleSubmit}
            size="small"
            text="Run"
          />
        </div>
      </ActionsContainer>
      <StyledEditorWrapper>
        <div>
          <Card style={{ marginTop: '10px' }}>
            <Card.Section>
              <Text weight={500} className="editor__labels" size="sm">
                Query
              </Text>
              <Editor
                className="editor-transformation-response-query"
                data-testid={'editor-transformation-response-query'}
                placeholder="Type Query here"
                value={formik.values.query}
                onChange={e => formik.setFieldValue('query', e)}
              />
            </Card.Section>
            <Card.Section>
              <Text weight={500} className="editor__labels" size="sm">
                Header
              </Text>
              <Editor
                className="editor-transformation-header-error"
                placeholder="Type required header here"
                value={formik.values.headers}
                onChange={e => formik.setFieldValue('headers', e)}
              />
            </Card.Section>
          </Card>
        </div>
        <div>
          {loading && <FormLoader theme="dark" rowCount={5} />}
          {!loading && (
            <Card style={{ marginTop: '10px' }}>
              <Card.Section>
                <Text weight={500} className="editor__labels" size="sm">
                  Transformation Result
                </Text>
                <Editor
                  className="editor-transformation-response-query"
                  readOnly={true}
                  required={true}
                  value={formik.values.transformationResult}
                  placeholder="Expected Transformation Output"
                />
              </Card.Section>
              {errorsWithData && (
                <Card.Section>
                  <Text weight={500} className="editor__labels" size="sm">
                    Errors in endpoints
                  </Text>
                  <Editor
                    className="editor-transformation-header-error"
                    placeholder="Errors which will come in endpoint will show here"
                    readOnly={true}
                    value={formik.values.errorsWithData}
                    onChange={e => formik.setFieldValue('errorsWithData', e)}
                  />
                </Card.Section>
              )}
            </Card>
          )}
        </div>
      </StyledEditorWrapper>
    </StyledContainer>
  );
};

export default TestTransformations;
